<template>
    <span class="spinner"></span>
</template>
